import { createSlice, current } from '@reduxjs/toolkit';

export function getOneFlowTimeById(flowTime, id) {
  const flow = flowTime.flows.find((item) => item.flowId === id);
  return flow
    ? flow
    : {
        flowId: id,
        ftStatus: 'idle',
        stats: [],
        realStats: [],
        branchTime: 0,
        doneTime: 0,
        donePreventTime: 0,
      };
}

const flowTime = createSlice({
  name: 'flowtime',
  initialState: { flows: [], status: 'idle' },
  reducers: {
    loadOne: (state, action) => {
      const flowId = action.payload.flowId;

      const alreadyExists = state.flows.find((item) => item.flowId === flowId);

      if (alreadyExists) {
        state.flows = state.flows.map((item) => {
          if (item.flowId === flowId) {
            item = {
              ...item,
              stats: action.payload.stats,
              realStats: action.payload.realStats,
              branchTime: action.payload.branchTime,
              doneTime: action.payload.doneTime,
              donePreventTime: action.payload.donePreventTime,
            };
          }
          return item;
        });
      } else {
        state.flows.push({
          flowId: action.payload.flowId,
          stats: action.payload.stats,
          realStats: action.payload.realStats,
          branchTime: action.payload.branchTime,
          doneTime: action.payload.doneTime,
          donePreventTime: action.payload.donePreventTime,
          ftStatus: 'succeeded',
        });
      }
      state.status = 'succeeded';
    },
  },
});
export const { loadOne } = flowTime.actions;
export default flowTime.reducer;
